import { useCallback, useState } from 'react'
import InputField from '../../../components/InputField'
import ApiRoute from '../../../components/ApiRoute'

const PredictPlans = ({ callApiFn, isApiCalling }) => {
  const [suppCount, setSuppCount] = useState('3')

  const getPredictPlans = useCallback(() => {
    const query = {}
    if (suppCount) query.suppCount = suppCount
    const hasQuery = Object.keys(query).length > 0

    callApiFn({
      method: 'GET',
      route: 'contact/{id}/predictPlans',
      ...(hasQuery ? { query } : {})
    })
  }, [suppCount, callApiFn])

  return (
    <div>
      <InputField labelFor='ppSuppCount' type='text' id='ppSuppCount' name='ppSuppCount' onChange={(e) => setSuppCount(e.target.value)} value={suppCount}>
        Supp. Count
      </InputField>
      <ApiRoute method='GET' route='/contact/{contactId}/predictPlans' onClick={getPredictPlans} disabled={isApiCalling} />
    </div>
  )
}

export default PredictPlans
